import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LocalCampaignMedia } from '../../../helpers/enum';
import { RenaultLocalCampaignDTO } from '../../../models/renault-local-campaign-dto';

@Component({
  selector: 'local-campaign-test-send-modal',
  templateUrl: './local-campaign-test-send-modal.component.html',
  styleUrls: ['./local-campaign-test-send-modal.component.scss']
})
export class LocalCampaignTestSendComponent {

  @Input() model: RenaultLocalCampaignDTO;
  contact: string = '';
  LocalCampaignMedia = LocalCampaignMedia;

  constructor(public activeModal: NgbActiveModal,
    private toastr: ToastrService) { }

  sendTest() {
    if (this.contact.length > 0) {
      if (this.model.IdCampaignMedia == LocalCampaignMedia.Email) {
        const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var res = mailRegex.test(this.contact);

        if (!res) {
          this.toastr.error("Debes ingresar un email con formato válido");
          return;
        }
      } else if (this.model.IdCampaignMedia == LocalCampaignMedia.Sms) {
        const phoneRegex = /^([0-9]{9})$/;
        var res = phoneRegex.test(this.contact);
        if (!res) {
          this.toastr.error("Debes ingresar un teléfono con formato válido");
          return;
        }
      }
      this.activeModal.close(this.contact);
    }
    else {
      this.toastr.error("Debes indicar un contacto");
    }
  }

}
